import React from 'react';
import '../styles/ProjectItem.css';
import { useNavigate } from 'react-router-dom';

const ProjectItem = ({ image, name, index }) => {

  const navigate = useNavigate();

  return (
    <div className='projectItem' onClick={() => (navigate("/project/" + index ))}>
        <div style={{backgroundImage: `url(${image})`}} className='bgImage'/>
        <h1>{name}</h1>
    </div>
  )
}

export default ProjectItem